// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LandingRouteRouteImport } from './routes/_landing/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as LandingIndexRouteImport } from './routes/_landing/index'
import { Route as LandingTermsOfUseRouteImport } from './routes/_landing/terms-of-use'
import { Route as LandingProfessionalsRouteImport } from './routes/_landing/professionals'
import { Route as LandingPrivacyPolicyRouteImport } from './routes/_landing/privacy-policy'
import { Route as LandingDocsRouteImport } from './routes/_landing/docs'
import { Route as LandingCookiesPolicyRouteImport } from './routes/_landing/cookies-policy'
import { Route as AppTeamsRouteImport } from './routes/_app/teams'
import { Route as AppReportRouteImport } from './routes/_app/report'
import { Route as AppOrgsRouteImport } from './routes/_app/orgs'
import { Route as AppOffersRouteImport } from './routes/_app/offers'
import { Route as AppMarketRouteImport } from './routes/_app/market'
import { Route as AppJobsRouteImport } from './routes/_app/jobs'
import { Route as AppEmployeesRouteImport } from './routes/_app/employees'
import { Route as AppCheckoutRouteImport } from './routes/_app/checkout'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppTestIndexRouteImport } from './routes/_app/test.index'
import { Route as AppRegisterIndexRouteImport } from './routes/_app/register.index'
import { Route as AppDevResourcesIndexRouteImport } from './routes/_app/dev-resources.index'
import { Route as AppTestValuesRouteImport } from './routes/_app/test.values'
import { Route as AppTestPersonalityRouteImport } from './routes/_app/test.personality'
import { Route as AppTestCompetencesRouteImport } from './routes/_app/test.competences'
import { Route as AppRegisterCompanyRouteImport } from './routes/_app/register.company'
import { Route as AppRegisterApplicantRouteImport } from './routes/_app/register.applicant'
import { Route as AppBetaGenerateRouteImport } from './routes/_app/beta.generate'
import { Route as AppPublicLoginRouteImport } from './routes/_app/_public.login'
import { Route as AppPublicBeginPasswordResetRouteImport } from './routes/_app/_public.begin-password-reset'
import { Route as AppTeamsIndexRouteImport } from './routes/_app/teams.index'
import { Route as AppTeamsTeamIdRouteImport } from './routes/_app/teams.$teamId'
import { Route as AppOrgsIndexRouteImport } from './routes/_app/orgs.index'
import { Route as AppOffersIndexRouteImport } from './routes/_app/offers.index'
import { Route as AppOffersOfferIdRouteImport } from './routes/_app/offers.$offerId'
import { Route as AppJobsIndexRouteImport } from './routes/_app/jobs.index'
import { Route as AppJobsJobIdRouteImport } from './routes/_app/jobs.$jobId'
import { Route as AppEmployeesIndexRouteImport } from './routes/_app/employees.index'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account.index'
import { Route as AppAccountBillingRouteImport } from './routes/_app/account.billing'
import { Route as AppAccountApiRouteImport } from './routes/_app/account.api'
import { Route as AppPublicVerifyEmailTokenRouteImport } from './routes/_app/_public.verify-email.$token'
import { Route as AppPublicUpdatePasswordTokenRouteImport } from './routes/_app/_public.update-password.$token'
import { Route as AppPublicEmployeeInvitationTokenRouteImport } from './routes/_app/_public.employee-invitation.$token'
import { Route as AppTeamsTeamIdReportRouteImport } from './routes/_app/teams.$teamId.report'
import { Route as AppTeamsTeamIdEvaluationRouteImport } from './routes/_app/teams.$teamId.evaluation'
import { Route as AppTeamsTeamIdEvaluateRouteImport } from './routes/_app/teams.$teamId.evaluate'
import { Route as AppTeamsTeamIdDistributionRouteImport } from './routes/_app/teams.$teamId.distribution'
import { Route as AppTeamsTeamIdBoardRouteImport } from './routes/_app/teams.$teamId.board'
import { Route as AppOrgsOrgIdIndexRouteImport } from './routes/_app/orgs.$orgId.index'
import { Route as AppOffersOfferIdIndexRouteImport } from './routes/_app/offers.$offerId.index'
import { Route as AppOffersOfferIdReportRouteImport } from './routes/_app/offers.$offerId.report'
import { Route as AppOffersOfferIdDistributionRouteImport } from './routes/_app/offers.$offerId.distribution'
import { Route as AppOffersOfferIdBoardRouteImport } from './routes/_app/offers.$offerId.board'
import { Route as AppJobsJobIdReportRouteImport } from './routes/_app/jobs.$jobId.report'
import { Route as AppJobsJobIdDistributionRouteImport } from './routes/_app/jobs.$jobId.distribution'
import { Route as AppJobsJobIdBoardRouteImport } from './routes/_app/jobs.$jobId.board'
import { Route as AppEmployeesEmployeeIdReportRouteImport } from './routes/_app/employees.$employeeId.report'
import { Route as AppAccountApiIndexRouteImport } from './routes/_app/account.api.index'
import { Route as AppAccountApiAppIdRouteImport } from './routes/_app/account.api.$appId'
import { Route as AppOrgsOrgIdUsersGroupsRouteImport } from './routes/_app/orgs_.$orgId.users.groups'
import { Route as AppOrgsOrgIdGroupsGroupIdRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId'
import { Route as AppAccountApiAppIdIndexRouteImport } from './routes/_app/account.api.$appId.index'
import { Route as AppAccountApiAppIdSettingsRouteImport } from './routes/_app/account.api.$appId.settings'
import { Route as AppAccountApiAppIdPlaygroundRouteImport } from './routes/_app/account.api.$appId.playground'
import { Route as AppAccountApiAppIdJobsRouteImport } from './routes/_app/account.api.$appId.jobs'
import { Route as AppAccountApiAppIdCompaniesRouteImport } from './routes/_app/account.api.$appId.companies'
import { Route as AppAccountApiAppIdApplicantsRouteImport } from './routes/_app/account.api.$appId.applicants'
import { Route as AppOrgsOrgIdUsersGroupsIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.index'
import { Route as AppOrgsOrgIdGroupsGroupIdReportRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.report'
import { Route as AppOrgsOrgIdGroupsGroupIdDistributionRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.distribution'
import { Route as AppOrgsOrgIdGroupsGroupIdBoardRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.board'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.index'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.describe.index'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.describe.$indicator.$step'

const LandingRouteRoute = LandingRouteRouteImport.update({
            id: '/_landing',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const LandingIndexRoute = LandingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LandingRouteRoute
          })
const LandingTermsOfUseRoute = LandingTermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => LandingRouteRoute
          })
const LandingProfessionalsRoute = LandingProfessionalsRouteImport.update({
            id: '/professionals',path: '/professionals',getParentRoute: () => LandingRouteRoute
          })
const LandingPrivacyPolicyRoute = LandingPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => LandingRouteRoute
          })
const LandingDocsRoute = LandingDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => LandingRouteRoute
          })
const LandingCookiesPolicyRoute = LandingCookiesPolicyRouteImport.update({
            id: '/cookies-policy',path: '/cookies-policy',getParentRoute: () => LandingRouteRoute
          })
const AppTeamsRoute = AppTeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => AppRouteRoute
          })
const AppReportRoute = AppReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppRouteRoute
          })
const AppOrgsRoute = AppOrgsRouteImport.update({
            id: '/orgs',path: '/orgs',getParentRoute: () => AppRouteRoute
          })
const AppOffersRoute = AppOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => AppRouteRoute
          })
const AppMarketRoute = AppMarketRouteImport.update({
            id: '/market',path: '/market',getParentRoute: () => AppRouteRoute
          })
const AppJobsRoute = AppJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppRouteRoute
          })
const AppEmployeesRoute = AppEmployeesRouteImport.update({
            id: '/employees',path: '/employees',getParentRoute: () => AppRouteRoute
          })
const AppCheckoutRoute = AppCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => AppRouteRoute
          })
const AppAccountRoute = AppAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppRouteRoute
          })
const AppTestIndexRoute = AppTestIndexRouteImport.update({
            id: '/test/',path: '/test/',getParentRoute: () => AppRouteRoute
          })
const AppRegisterIndexRoute = AppRegisterIndexRouteImport.update({
            id: '/register/',path: '/register/',getParentRoute: () => AppRouteRoute
          })
const AppDevResourcesIndexRoute = AppDevResourcesIndexRouteImport.update({
            id: '/dev-resources/',path: '/dev-resources/',getParentRoute: () => AppRouteRoute
          })
const AppTestValuesRoute = AppTestValuesRouteImport.update({
            id: '/test/values',path: '/test/values',getParentRoute: () => AppRouteRoute
          })
const AppTestPersonalityRoute = AppTestPersonalityRouteImport.update({
            id: '/test/personality',path: '/test/personality',getParentRoute: () => AppRouteRoute
          })
const AppTestCompetencesRoute = AppTestCompetencesRouteImport.update({
            id: '/test/competences',path: '/test/competences',getParentRoute: () => AppRouteRoute
          })
const AppRegisterCompanyRoute = AppRegisterCompanyRouteImport.update({
            id: '/register/company',path: '/register/company',getParentRoute: () => AppRouteRoute
          })
const AppRegisterApplicantRoute = AppRegisterApplicantRouteImport.update({
            id: '/register/applicant',path: '/register/applicant',getParentRoute: () => AppRouteRoute
          })
const AppBetaGenerateRoute = AppBetaGenerateRouteImport.update({
            id: '/beta/generate',path: '/beta/generate',getParentRoute: () => AppRouteRoute
          })
const AppPublicLoginRoute = AppPublicLoginRouteImport.update({
            id: '/_public/login',path: '/login',getParentRoute: () => AppRouteRoute
          })
const AppPublicBeginPasswordResetRoute = AppPublicBeginPasswordResetRouteImport.update({
            id: '/_public/begin-password-reset',path: '/begin-password-reset',getParentRoute: () => AppRouteRoute
          })
const AppTeamsIndexRoute = AppTeamsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppTeamsRoute
          })
const AppTeamsTeamIdRoute = AppTeamsTeamIdRouteImport.update({
            id: '/$teamId',path: '/$teamId',getParentRoute: () => AppTeamsRoute
          })
const AppOrgsIndexRoute = AppOrgsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsRoute
          })
const AppOffersIndexRoute = AppOffersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOffersRoute
          })
const AppOffersOfferIdRoute = AppOffersOfferIdRouteImport.update({
            id: '/$offerId',path: '/$offerId',getParentRoute: () => AppOffersRoute
          })
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppJobsRoute
          })
const AppJobsJobIdRoute = AppJobsJobIdRouteImport.update({
            id: '/$jobId',path: '/$jobId',getParentRoute: () => AppJobsRoute
          })
const AppEmployeesIndexRoute = AppEmployeesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppEmployeesRoute
          })
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountRoute
          })
const AppAccountBillingRoute = AppAccountBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppAccountRoute
          })
const AppAccountApiRoute = AppAccountApiRouteImport.update({
            id: '/api',path: '/api',getParentRoute: () => AppAccountRoute
          })
const AppPublicVerifyEmailTokenRoute = AppPublicVerifyEmailTokenRouteImport.update({
            id: '/_public/verify-email/$token',path: '/verify-email/$token',getParentRoute: () => AppRouteRoute
          })
const AppPublicUpdatePasswordTokenRoute = AppPublicUpdatePasswordTokenRouteImport.update({
            id: '/_public/update-password/$token',path: '/update-password/$token',getParentRoute: () => AppRouteRoute
          })
const AppPublicEmployeeInvitationTokenRoute = AppPublicEmployeeInvitationTokenRouteImport.update({
            id: '/_public/employee-invitation/$token',path: '/employee-invitation/$token',getParentRoute: () => AppRouteRoute
          })
const AppTeamsTeamIdReportRoute = AppTeamsTeamIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdEvaluationRoute = AppTeamsTeamIdEvaluationRouteImport.update({
            id: '/evaluation',path: '/evaluation',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdEvaluateRoute = AppTeamsTeamIdEvaluateRouteImport.update({
            id: '/evaluate',path: '/evaluate',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdDistributionRoute = AppTeamsTeamIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdBoardRoute = AppTeamsTeamIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppOrgsOrgIdIndexRoute = AppOrgsOrgIdIndexRouteImport.update({
            id: '/$orgId/',path: '/$orgId/',getParentRoute: () => AppOrgsRoute
          })
const AppOffersOfferIdIndexRoute = AppOffersOfferIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOffersOfferIdRoute
          })
const AppOffersOfferIdReportRoute = AppOffersOfferIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppOffersOfferIdRoute
          })
const AppOffersOfferIdDistributionRoute = AppOffersOfferIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppOffersOfferIdRoute
          })
const AppOffersOfferIdBoardRoute = AppOffersOfferIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppOffersOfferIdRoute
          })
const AppJobsJobIdReportRoute = AppJobsJobIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppJobsJobIdRoute
          })
const AppJobsJobIdDistributionRoute = AppJobsJobIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppJobsJobIdRoute
          })
const AppJobsJobIdBoardRoute = AppJobsJobIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppJobsJobIdRoute
          })
const AppEmployeesEmployeeIdReportRoute = AppEmployeesEmployeeIdReportRouteImport.update({
            id: '/$employeeId/report',path: '/$employeeId/report',getParentRoute: () => AppEmployeesRoute
          })
const AppAccountApiIndexRoute = AppAccountApiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiRoute
          })
const AppAccountApiAppIdRoute = AppAccountApiAppIdRouteImport.update({
            id: '/$appId',path: '/$appId',getParentRoute: () => AppAccountApiRoute
          })
const AppOrgsOrgIdUsersGroupsRoute = AppOrgsOrgIdUsersGroupsRouteImport.update({
            id: '/orgs_/$orgId/users/groups',path: '/orgs/$orgId/users/groups',getParentRoute: () => AppRouteRoute
          })
const AppOrgsOrgIdGroupsGroupIdRoute = AppOrgsOrgIdGroupsGroupIdRouteImport.update({
            id: '/$orgId/groups/$groupId',path: '/$orgId/groups/$groupId',getParentRoute: () => AppOrgsRoute
          })
const AppAccountApiAppIdIndexRoute = AppAccountApiAppIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdSettingsRoute = AppAccountApiAppIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdPlaygroundRoute = AppAccountApiAppIdPlaygroundRouteImport.update({
            id: '/playground',path: '/playground',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdJobsRoute = AppAccountApiAppIdJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdCompaniesRoute = AppAccountApiAppIdCompaniesRouteImport.update({
            id: '/companies',path: '/companies',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdApplicantsRoute = AppAccountApiAppIdApplicantsRouteImport.update({
            id: '/applicants',path: '/applicants',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppOrgsOrgIdUsersGroupsIndexRoute = AppOrgsOrgIdUsersGroupsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppOrgsOrgIdGroupsGroupIdReportRoute = AppOrgsOrgIdGroupsGroupIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdDistributionRoute = AppOrgsOrgIdGroupsGroupIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdBoardRoute = AppOrgsOrgIdGroupsGroupIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdIndexRoute = AppOrgsOrgIdUsersGroupsGroupIdIndexRouteImport.update({
            id: '/$groupId/',path: '/$groupId/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute = AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRouteImport.update({
            id: '/$groupId/describe/',path: '/$groupId/describe/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute = AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRouteImport.update({
            id: '/$groupId/describe/$indicator/$step',path: '/$groupId/describe/$indicator/$step',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })





const AppAccountApiAppIdRouteChildren = {
  AppAccountApiAppIdApplicantsRoute: AppAccountApiAppIdApplicantsRoute,AppAccountApiAppIdCompaniesRoute: AppAccountApiAppIdCompaniesRoute,AppAccountApiAppIdJobsRoute: AppAccountApiAppIdJobsRoute,AppAccountApiAppIdPlaygroundRoute: AppAccountApiAppIdPlaygroundRoute,AppAccountApiAppIdSettingsRoute: AppAccountApiAppIdSettingsRoute,AppAccountApiAppIdIndexRoute: AppAccountApiAppIdIndexRoute
}

const AppAccountApiAppIdRouteWithChildren = AppAccountApiAppIdRoute._addFileChildren(AppAccountApiAppIdRouteChildren)



const AppAccountApiRouteChildren = {
  AppAccountApiAppIdRoute: AppAccountApiAppIdRouteWithChildren,AppAccountApiIndexRoute: AppAccountApiIndexRoute
}

const AppAccountApiRouteWithChildren = AppAccountApiRoute._addFileChildren(AppAccountApiRouteChildren)



const AppAccountRouteChildren = {
  AppAccountApiRoute: AppAccountApiRouteWithChildren,AppAccountBillingRoute: AppAccountBillingRoute,AppAccountIndexRoute: AppAccountIndexRoute
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(AppAccountRouteChildren)




const AppEmployeesRouteChildren = {
  AppEmployeesIndexRoute: AppEmployeesIndexRoute,AppEmployeesEmployeeIdReportRoute: AppEmployeesEmployeeIdReportRoute
}

const AppEmployeesRouteWithChildren = AppEmployeesRoute._addFileChildren(AppEmployeesRouteChildren)




const AppJobsJobIdRouteChildren = {
  AppJobsJobIdBoardRoute: AppJobsJobIdBoardRoute,AppJobsJobIdDistributionRoute: AppJobsJobIdDistributionRoute,AppJobsJobIdReportRoute: AppJobsJobIdReportRoute
}

const AppJobsJobIdRouteWithChildren = AppJobsJobIdRoute._addFileChildren(AppJobsJobIdRouteChildren)



const AppJobsRouteChildren = {
  AppJobsJobIdRoute: AppJobsJobIdRouteWithChildren,AppJobsIndexRoute: AppJobsIndexRoute
}

const AppJobsRouteWithChildren = AppJobsRoute._addFileChildren(AppJobsRouteChildren)




const AppOffersOfferIdRouteChildren = {
  AppOffersOfferIdBoardRoute: AppOffersOfferIdBoardRoute,AppOffersOfferIdDistributionRoute: AppOffersOfferIdDistributionRoute,AppOffersOfferIdReportRoute: AppOffersOfferIdReportRoute,AppOffersOfferIdIndexRoute: AppOffersOfferIdIndexRoute
}

const AppOffersOfferIdRouteWithChildren = AppOffersOfferIdRoute._addFileChildren(AppOffersOfferIdRouteChildren)



const AppOffersRouteChildren = {
  AppOffersOfferIdRoute: AppOffersOfferIdRouteWithChildren,AppOffersIndexRoute: AppOffersIndexRoute
}

const AppOffersRouteWithChildren = AppOffersRoute._addFileChildren(AppOffersRouteChildren)




const AppOrgsOrgIdGroupsGroupIdRouteChildren = {
  AppOrgsOrgIdGroupsGroupIdBoardRoute: AppOrgsOrgIdGroupsGroupIdBoardRoute,AppOrgsOrgIdGroupsGroupIdDistributionRoute: AppOrgsOrgIdGroupsGroupIdDistributionRoute,AppOrgsOrgIdGroupsGroupIdReportRoute: AppOrgsOrgIdGroupsGroupIdReportRoute
}

const AppOrgsOrgIdGroupsGroupIdRouteWithChildren = AppOrgsOrgIdGroupsGroupIdRoute._addFileChildren(AppOrgsOrgIdGroupsGroupIdRouteChildren)



const AppOrgsRouteChildren = {
  AppOrgsIndexRoute: AppOrgsIndexRoute,AppOrgsOrgIdIndexRoute: AppOrgsOrgIdIndexRoute,AppOrgsOrgIdGroupsGroupIdRoute: AppOrgsOrgIdGroupsGroupIdRouteWithChildren
}

const AppOrgsRouteWithChildren = AppOrgsRoute._addFileChildren(AppOrgsRouteChildren)




const AppTeamsTeamIdRouteChildren = {
  AppTeamsTeamIdBoardRoute: AppTeamsTeamIdBoardRoute,AppTeamsTeamIdDistributionRoute: AppTeamsTeamIdDistributionRoute,AppTeamsTeamIdEvaluateRoute: AppTeamsTeamIdEvaluateRoute,AppTeamsTeamIdEvaluationRoute: AppTeamsTeamIdEvaluationRoute,AppTeamsTeamIdReportRoute: AppTeamsTeamIdReportRoute
}

const AppTeamsTeamIdRouteWithChildren = AppTeamsTeamIdRoute._addFileChildren(AppTeamsTeamIdRouteChildren)



const AppTeamsRouteChildren = {
  AppTeamsTeamIdRoute: AppTeamsTeamIdRouteWithChildren,AppTeamsIndexRoute: AppTeamsIndexRoute
}

const AppTeamsRouteWithChildren = AppTeamsRoute._addFileChildren(AppTeamsRouteChildren)




const AppOrgsOrgIdUsersGroupsRouteChildren = {
  AppOrgsOrgIdUsersGroupsIndexRoute: AppOrgsOrgIdUsersGroupsIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdIndexRoute: AppOrgsOrgIdUsersGroupsGroupIdIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute: AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute: AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute
}

const AppOrgsOrgIdUsersGroupsRouteWithChildren = AppOrgsOrgIdUsersGroupsRoute._addFileChildren(AppOrgsOrgIdUsersGroupsRouteChildren)



const AppRouteRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,AppCheckoutRoute: AppCheckoutRoute,AppEmployeesRoute: AppEmployeesRouteWithChildren,AppJobsRoute: AppJobsRouteWithChildren,AppMarketRoute: AppMarketRoute,AppOffersRoute: AppOffersRouteWithChildren,AppOrgsRoute: AppOrgsRouteWithChildren,AppReportRoute: AppReportRoute,AppTeamsRoute: AppTeamsRouteWithChildren,AppPublicBeginPasswordResetRoute: AppPublicBeginPasswordResetRoute,AppPublicLoginRoute: AppPublicLoginRoute,AppBetaGenerateRoute: AppBetaGenerateRoute,AppRegisterApplicantRoute: AppRegisterApplicantRoute,AppRegisterCompanyRoute: AppRegisterCompanyRoute,AppTestCompetencesRoute: AppTestCompetencesRoute,AppTestPersonalityRoute: AppTestPersonalityRoute,AppTestValuesRoute: AppTestValuesRoute,AppDevResourcesIndexRoute: AppDevResourcesIndexRoute,AppRegisterIndexRoute: AppRegisterIndexRoute,AppTestIndexRoute: AppTestIndexRoute,AppPublicEmployeeInvitationTokenRoute: AppPublicEmployeeInvitationTokenRoute,AppPublicUpdatePasswordTokenRoute: AppPublicUpdatePasswordTokenRoute,AppPublicVerifyEmailTokenRoute: AppPublicVerifyEmailTokenRoute,AppOrgsOrgIdUsersGroupsRoute: AppOrgsOrgIdUsersGroupsRouteWithChildren
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const LandingRouteRouteChildren = {
  LandingCookiesPolicyRoute: LandingCookiesPolicyRoute,LandingDocsRoute: LandingDocsRoute,LandingPrivacyPolicyRoute: LandingPrivacyPolicyRoute,LandingProfessionalsRoute: LandingProfessionalsRoute,LandingTermsOfUseRoute: LandingTermsOfUseRoute,LandingIndexRoute: LandingIndexRoute
}

const LandingRouteRouteWithChildren = LandingRouteRoute._addFileChildren(LandingRouteRouteChildren)

const rootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,LandingRouteRoute: LandingRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)